<script>
export default {
    data() {

        return {
            imageUpload: '',
            imageAvatar: '',
            imageUploaded: {
                avatar: '',
                background: ''
            },
            criar: true,
            showDisplay: false
        }
    },
    methods: {
        showModal() {

            var vm = this;

            $(".loading").show();
            axios.get("/adm/configuracoes_globais/login_avatar").then(function (response) {
                vm.imageUploaded.avatar = response.data.valor;
            }).catch(function (errors) {
                alert("houve uma falha \n" + errors.errors.join());
                console.log(errors);
                $(".loading").hide();
            });

            axios.get("/adm/configuracoes_globais/login_background").then(function (response) {
                vm.imageUploaded.background = response.data.valor;
                $(".loading").hide();
                vm.showDisplay = true;
            }).catch(function (errors) {
                alert("houve uma falha \n" + errors.errors.join());
                console.log(errors);
                $(".loading").hide();
            });

        },
        save() {
            var vm = this;
            var route = "/adm/configuracoes_globais";
            var data = [

                {
                    chave: "login_avatar",
                    valor: this.imageUploaded.avatar
                },
                {
                    chave: "login_background",
                    valor: this.imageUploaded.background
                }

            ];
            $(".loading").show();
            axios.post(route, data).then(function (response) {

                $(".loading").hide();
                vm.showDisplay = false;
            }).catch(function (errors) {
                alert("houve uma falha \n" + errors.errors.join());
                console.log(errors);
                $(".loading").hide();
            });
        },
        onFileChange(e, image) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;

            this.createImage(files[0], image);
        },
        createImage(file, keyImage) {
            console.log(keyImage);
            var image = new Image();
            var reader = new FileReader();
            var vm = this;
            var keyImage = keyImage;

            reader.onload = (e) => {
                vm.imageUploaded[keyImage] = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        removeImage(keyImage) {
            this.imageUploaded[keyImage] = '';
        },
    }
}
</script>

<template>
<div>
    <a href="#" @click.prevent="showModal">
        <slot />
    </a>

    <!-- Modal -->
    <b-modal v-model="showDisplay" title="Imagens para tela de Login" hide-footer>
        <b-card>
            <b-card-body>
                <div class="row">
                    <div class="col-md-12">
                        <div v-if="!imageUploaded.avatar">
                            <h2 v-if='criar'>Avatar</h2>
                            <h2 v-else>Escolha um novo avatar</h2>
                            <b-form-file placeholder="Selecione o arquivo" @change="onFileChange($event,'avatar')" browse-text="Procurar" />
                        </div>
                        <div v-else>
                            <img :src="imageUploaded.avatar" class="avatar-image" />
                            <div class="row">
                                <b-button variant="danger" size="sm" class="mt-3" @click="removeImage('avatar')">Remover Avatar</b-button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <hr>
                    </div>
                    <div class="col-md-12">
                        <div v-if="!imageUploaded.background">
                            <h2 v-if='criar'>Background</h2>
                            <h2 v-else>Escolha um novo Background</h2>
                            <b-form-file placeholder="Selecione o arquivo" @change="onFileChange($event,'background')" browse-text="Procurar" />
                        </div>
                        <div v-else>
                            <img :src="imageUploaded.background" class="background-image" />
                            <b-button variant="danger" size="sm" class="mt-3" @click="removeImage('background')">Remover Background</b-button>
                        </div>
                    </div>
                </div>
            </b-card-body>
            <b-card-footer>
                <b-button variant="danger" size="sm" class="float-right" @click="showDisplay = false">Cancelar</b-button>
                <b-button variant="primary" size="sm" class="mr-2 float-right" @click="save">Salvar</b-button>
            </b-card-footer>
        </b-card>
    </b-modal>

</div>
</template>

<style scoped>
.avatar-image {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    text-align: center;

}

.background-image {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/Home/CustomLoginPage.vue